module.exports = __webpack_public_path__ + "img/launchpad-banner-bg-sm.5547b9b7.png";